import {createSlice} from "@reduxjs/toolkit";

const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  deviceForMonitoring: undefined,
  deviceRisk: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const devicesSlice = createSlice({
  name: "devices",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error.clientMessage}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductById
    deviceFetched: (state, action) => {
      state.actionsLoading = false;
      state.deviceForMonitoring = action.payload.deviceForMonitoring;
      state.error = null;
    },
    // get device risk
    deviceRisk: (state, action) => {
      state.actionsLoading = false;
      state.deviceRiskForMonitoring = action.payload.deviceRiskForMonitoring;
      state.error = null;
    },
    // findProducts
    devicesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
  }
});
